import { asks } from 'fp-ts/lib/Reader';
import { toRemoteData } from '../../utils/axios';
export var chatHQ = asks(function (_a) {
    var axios = _a.axios;
    var getChannels = function (productId, integrationId) {
        return toRemoteData(axios.get("/api/products/" + productId + "/integrations/" + integrationId + "/chathq-channels"));
    };
    return {
        getChannels: getChannels,
    };
});
//# sourceMappingURL=chathq.service.js.map